@if (isVisible()) {
  <div
    class="ui-lm__backdrop"
    role="dialog"
    aria-modal="true"
    [attr.aria-label]="currentTitle() || dialogLabel()"
    (click)="onBackdropClick()"
  >
    <div class="ui-lm__card" (click)="$event.stopPropagation()">

      <!-- ── Ícono / Spinner ──────────────────────────────────────────────── -->
      <div
        [class]="iconWrapClass()"
        [class.ui-lm__icon-wrap--solo]="!currentTitle() && !currentMessage()"
        aria-hidden="true"
      >

        @if (currentVariant() === 'loading') {
          <div class="ui-lm__spinner"></div>
        }

        @if (isSuccess()) {
          <svg class="ui-lm__svg" viewBox="0 0 24 24" fill="none"
               stroke="currentColor" stroke-width="1.5">
            <circle class="ui-lm__circle" cx="12" cy="12" r="9" />
            <path   class="ui-lm__check"  d="M8 12.5l2.6 2.6L16.5 9.5" />
          </svg>
        }

        @if (isError()) {
          <svg class="ui-lm__svg" viewBox="0 0 24 24" fill="none"
               stroke="currentColor" stroke-width="1.5">
            <circle class="ui-lm__circle" cx="12" cy="12" r="9" />
            <path   class="ui-lm__x-1"   d="M9 9l6 6" />
            <path   class="ui-lm__x-2"   d="M15 9l-6 6" />
          </svg>
        }

        @if (isWarning()) {
          <svg class="ui-lm__svg" viewBox="0 0 24 24" fill="none"
               stroke="currentColor" stroke-width="1.2">
            <path   class="ui-lm__triangle" d="M12 3.8 21 19H3L12 3.8z" />
            <path   class="ui-lm__line"     d="M12 10v3" />
            <circle class="ui-lm__dot"      cx="12" cy="16" r="1" />
          </svg>
        }

      </div>

      <!-- ── Textos ───────────────────────────────────────────────────────── -->
      <!-- aria-live aquí para que solo el título sea anunciado por el lector  -->
      <!-- de pantalla al aparecer, evitando doble anuncio con role="dialog". -->
      @if (currentTitle()) {
        <h2 class="ui-lm__title" aria-live="assertive" aria-atomic="true">{{ currentTitle() }}</h2>
      }

      @if (currentMessage()) {
        <p class="ui-lm__message">{{ currentMessage() }}</p>
      }

      <!-- ── Botones de acción ────────────────────────────────────────────── -->
      @if (hasActions()) {
        <div
          class="ui-lm__actions"
          [class.ui-lm__actions--single]="!currentShowCancelButton() || !currentShowButton()"
        >
          @if (currentShowCancelButton()) {
            <ui-button
              variant="secondary"
              size="md"
              [block]="true"
              (pressed)="onCancel()"
            >
              {{ currentCancelLabel() }}
            </ui-button>
          }

          @if (currentShowButton()) {
            <ui-button
              [variant]="currentConfirmDanger() ? 'danger' : 'primary'"
              size="md"
              [block]="true"
              (pressed)="onConfirm()"
            >
              {{ currentConfirmLabel() }}
            </ui-button>
          }
        </div>
      }

    </div>
  </div>
}
